// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListGroupModal-space1-mZjrV {
	margin-bottom: 6px !important;
}

.WishListGroupModal-space2-MQQTN {
	margin-bottom: 12px !important;
}

.WishListGroupModal-space3-ZRD7U {
	margin-bottom: 18px !important;
}

.WishListGroupModal-space4-BzjhW {
	margin-bottom: 24px !important;
}

.WishListGroupModal-space5-fX0h6 {
	margin-bottom: 30px !important;
}

.WishListGroupModal-space6-QsKrz {
	margin-bottom: 36px !important;
}

.WishListGroupModal-space7-qd4Aa {
	margin-bottom: 42px !important;
}

.WishListGroupModal-spaceTop8-aA1kw {
	margin-bottom: 48px !important;
}

.WishListGroupModal-spaceTop1-wQZC2 {
	margin-top: 6px !important;
}

.WishListGroupModal-spaceTop2-Ci_0u {
	margin-top: 12px !important;
}

.WishListGroupModal-spaceTop3-ZjA4t {
	margin-top: 18px !important;
}

.WishListGroupModal-spaceTop4-fxTO9 {
	margin-top: 24px !important;
}

.WishListGroupModal-spaceTop5-L0TlA {
	margin-top: 30px !important;
}

.WishListGroupModal-spaceTop6-UX7Ts {
	margin-top: 36px !important;
}

.WishListGroupModal-spaceTop7-_Z1qP {
	margin-top: 42px !important;
}

.WishListGroupModal-spaceTop8-aA1kw {
	margin-top: 48px !important;
}

.WishListGroupModal-noMargin-C7zVU {
	margin: 0px !important;
}

.WishListGroupModal-padding1-nDlDf {
	padding-bottom: 6px !important;
}

.WishListGroupModal-padding2-dZrQw {
	padding-bottom: 12px !important;
}

.WishListGroupModal-padding3-UiR37 {
	padding-bottom: 18px !important;
}

.WishListGroupModal-padding4-Dbe2K {
	padding-bottom: 24px !important;
}

.WishListGroupModal-padding5-orvhZ {
	padding-bottom: 30px !important;
}

.WishListGroupModal-padding6-iZhoN {
	padding-bottom: 36px !important;
}

.WishListGroupModal-padding7-aGju4 {
	padding-bottom: 42px !important;
}

.WishListGroupModal-paddingTop1-YqYBZ {
	padding-top: 6px !important;
}

.WishListGroupModal-paddingTop2-x_f3B {
	padding-top: 12px !important;
}

.WishListGroupModal-paddingTop3-JPcdx {
	padding-top: 18px !important;
}

.WishListGroupModal-paddingTop4-DoL0E {
	padding-top: 24px !important;
}

.WishListGroupModal-paddingTop5-eDBBX {
	padding-top: 30px !important;
}

.WishListGroupModal-paddingTop6-kK1pO {
	padding-top: 36px !important;
}

.WishListGroupModal-paddingTop7-RSiyz {
	padding-top: 42px !important;
}

.WishListGroupModal-noPadding-mGQDv {
	padding: 0px !important;
}

.WishListGroupModal-textBold-Su7pR {
	font-weight: 500 !important;
}

.WishListGroupModal-textBolder-G52NU {
	font-weight: 700 !important;
}

.WishListGroupModal-textNormal-QCHGt {
	font-weight: normal !important;
}

.WishListGroupModal-spaceBottom20-YHWtV {
	margin-bottom: 20px;
}

.WishListGroupModal-spaceBottom10-kR_aW {
	margin-bottom: 10px;
}

.WishListGroupModal-marginNone-TLS1l {
	margin: 0;
}

.WishListGroupModal-spaceBottom15-PnMrC {
	margin-bottom: 15px;
}

.WishListGroupModal-marginTopNone-VhKuO {
	margin-top: 0;
}

.WishListGroupModal-spaceTop11-CdloQ {
	margin-top: 11px;
}

.WishListGroupModal-spaceTop21-JAf3H {
	margin-top: 21px;
}

.WishListGroupModal-spaceTop20-Wv_O2 {
	margin-top: 20px;
}

.WishListGroupModal-spaceTop10-W3HhU {
	margin-top: 10px;
}

/*New Design Text Colors */

.WishListGroupModal-textDarkBlue-dvjl0 {
	color: rgb(20, 39, 94) !important;
}

.WishListGroupModal-textLightBlue-kdkPU {
	color: rgb(57, 87, 106) !important;
}

.WishListGroupModal-textLightSandleGreen-SoZGI {
	color: rgb(76, 86, 41) !important;
}

.WishListGroupModal-textLightBrown-UXc5B {
	color: rgb(115, 79, 33) !important;
}

.WishListGroupModal-textMediumMaroon-rIOc8 {
	color: rgb(87, 37, 51) !important;
}

.WishListGroupModal-textBrown-llS6E {
	color: rgb(160, 47, 24) !important;
}

.WishListGroupModal-textMaroon-xq93o {
	color: rgb(155, 49, 67) !important;
}

.WishListGroupModal-textDarkBrown-NFjVx {
	color: rgb(83, 18, 16) !important;
}

.WishListGroupModal-textMediumBrown-cKhCz {
	color: rgb(142, 28, 10) !important;
}

.WishListGroupModal-textSkyBlue-OsjSn {
	color: rgb(37, 117, 141) !important;
}

.WishListGroupModal-textGray-WvERs {
	color: rgb(77, 65, 51) !important;
}

.WishListGroupModal-root-jLUI6 {
	padding: 24px;
}

.WishListGroupModal-container-Kxrmc {
	margin: 0 auto;
	padding: 0px;
	max-width: 380px;
}

/** RentAll - Begin **/

.WishListGroupModal-logInModalContainer-PI0Dn {
	max-width: 450px;
	margin: 194px auto 0 auto;
}

.WishListGroupModal-logInModalBody-xd7BS {
	padding: 0px;
}

.WishListGroupModal-formGroup-hfINb {
	margin-bottom: 6px;
}

.WishListGroupModal-noPadding-mGQDv {
	padding: 0px;
}

.WishListGroupModal-titleBold-wWuD6 {
	font-size: 18px;
	margin: 0 0 12px;
}

.WishListGroupModal-containerPadding-y1Pg3 {
	padding-top: 20px;
	padding-bottom: 20px;
}

.WishListGroupModal-bodyText-kEBKo {
	font-size: 18px;
}

.WishListGroupModal-btnEnd-KbPuw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	margin-top: 55px;
	gap: 36px;
}

.WishListGroupModal-deleteCancel-Nyejq,
.WishListGroupModal-deleteCancel-Nyejq:hover,
.WishListGroupModal-deleteCancel-Nyejq:focus {
	border: unset;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
	color: var(--secondary-bg);
	font-size: 16px;
	padding: 0;
	font-weight: 500;
	background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/WishLists/WishListGroupModal/WishListGroupModal.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;;AAEA,sBAAsB;;AACtB;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,gBAAgB;CAChB,SAAS;AACV;;AAEA;;;CAGC,aAAa;CACb,yBAAiB;SAAjB,iBAAiB;CACjB,0BAA0B;CAC1B,eAAe;CACf,UAAU;CACV,gBAAgB;CAChB,uBAAuB;AACxB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../components/helpers.css';\n\n.root {\n\tpadding: 24px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0px;\n\tmax-width: 380px;\n}\n\n/** RentAll - Begin **/\n.logInModalContainer {\n\tmax-width: 450px;\n\tmargin: 194px auto 0 auto;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.titleBold {\n\tfont-size: 18px;\n\tmargin: 0 0 12px;\n}\n\n.containerPadding {\n\tpadding-top: 20px;\n\tpadding-bottom: 20px;\n}\n\n.bodyText {\n\tfont-size: 18px;\n}\n\n.btnEnd {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-top: 55px;\n\tgap: 36px;\n}\n\n.deleteCancel,\n.deleteCancel:hover,\n.deleteCancel:focus {\n\tborder: unset;\n\tbox-shadow: unset;\n\tcolor: var(--secondary-bg);\n\tfont-size: 16px;\n\tpadding: 0;\n\tfont-weight: 500;\n\tbackground: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WishListGroupModal-space1-mZjrV`,
	"space2": `WishListGroupModal-space2-MQQTN`,
	"space3": `WishListGroupModal-space3-ZRD7U`,
	"space4": `WishListGroupModal-space4-BzjhW`,
	"space5": `WishListGroupModal-space5-fX0h6`,
	"space6": `WishListGroupModal-space6-QsKrz`,
	"space7": `WishListGroupModal-space7-qd4Aa`,
	"spaceTop8": `WishListGroupModal-spaceTop8-aA1kw`,
	"spaceTop1": `WishListGroupModal-spaceTop1-wQZC2`,
	"spaceTop2": `WishListGroupModal-spaceTop2-Ci_0u`,
	"spaceTop3": `WishListGroupModal-spaceTop3-ZjA4t`,
	"spaceTop4": `WishListGroupModal-spaceTop4-fxTO9`,
	"spaceTop5": `WishListGroupModal-spaceTop5-L0TlA`,
	"spaceTop6": `WishListGroupModal-spaceTop6-UX7Ts`,
	"spaceTop7": `WishListGroupModal-spaceTop7-_Z1qP`,
	"noMargin": `WishListGroupModal-noMargin-C7zVU`,
	"padding1": `WishListGroupModal-padding1-nDlDf`,
	"padding2": `WishListGroupModal-padding2-dZrQw`,
	"padding3": `WishListGroupModal-padding3-UiR37`,
	"padding4": `WishListGroupModal-padding4-Dbe2K`,
	"padding5": `WishListGroupModal-padding5-orvhZ`,
	"padding6": `WishListGroupModal-padding6-iZhoN`,
	"padding7": `WishListGroupModal-padding7-aGju4`,
	"paddingTop1": `WishListGroupModal-paddingTop1-YqYBZ`,
	"paddingTop2": `WishListGroupModal-paddingTop2-x_f3B`,
	"paddingTop3": `WishListGroupModal-paddingTop3-JPcdx`,
	"paddingTop4": `WishListGroupModal-paddingTop4-DoL0E`,
	"paddingTop5": `WishListGroupModal-paddingTop5-eDBBX`,
	"paddingTop6": `WishListGroupModal-paddingTop6-kK1pO`,
	"paddingTop7": `WishListGroupModal-paddingTop7-RSiyz`,
	"noPadding": `WishListGroupModal-noPadding-mGQDv`,
	"textBold": `WishListGroupModal-textBold-Su7pR`,
	"textBolder": `WishListGroupModal-textBolder-G52NU`,
	"textNormal": `WishListGroupModal-textNormal-QCHGt`,
	"spaceBottom20": `WishListGroupModal-spaceBottom20-YHWtV`,
	"spaceBottom10": `WishListGroupModal-spaceBottom10-kR_aW`,
	"marginNone": `WishListGroupModal-marginNone-TLS1l`,
	"spaceBottom15": `WishListGroupModal-spaceBottom15-PnMrC`,
	"marginTopNone": `WishListGroupModal-marginTopNone-VhKuO`,
	"spaceTop11": `WishListGroupModal-spaceTop11-CdloQ`,
	"spaceTop21": `WishListGroupModal-spaceTop21-JAf3H`,
	"spaceTop20": `WishListGroupModal-spaceTop20-Wv_O2`,
	"spaceTop10": `WishListGroupModal-spaceTop10-W3HhU`,
	"textDarkBlue": `WishListGroupModal-textDarkBlue-dvjl0`,
	"textLightBlue": `WishListGroupModal-textLightBlue-kdkPU`,
	"textLightSandleGreen": `WishListGroupModal-textLightSandleGreen-SoZGI`,
	"textLightBrown": `WishListGroupModal-textLightBrown-UXc5B`,
	"textMediumMaroon": `WishListGroupModal-textMediumMaroon-rIOc8`,
	"textBrown": `WishListGroupModal-textBrown-llS6E`,
	"textMaroon": `WishListGroupModal-textMaroon-xq93o`,
	"textDarkBrown": `WishListGroupModal-textDarkBrown-NFjVx`,
	"textMediumBrown": `WishListGroupModal-textMediumBrown-cKhCz`,
	"textSkyBlue": `WishListGroupModal-textSkyBlue-OsjSn`,
	"textGray": `WishListGroupModal-textGray-WvERs`,
	"root": `WishListGroupModal-root-jLUI6`,
	"container": `WishListGroupModal-container-Kxrmc`,
	"logInModalContainer": `WishListGroupModal-logInModalContainer-PI0Dn`,
	"logInModalBody": `WishListGroupModal-logInModalBody-xd7BS`,
	"formGroup": `WishListGroupModal-formGroup-hfINb`,
	"titleBold": `WishListGroupModal-titleBold-wWuD6`,
	"containerPadding": `WishListGroupModal-containerPadding-y1Pg3`,
	"bodyText": `WishListGroupModal-bodyText-kEBKo`,
	"btnEnd": `WishListGroupModal-btnEnd-KbPuw`,
	"deleteCancel": `WishListGroupModal-deleteCancel-Nyejq`
};
module.exports = ___CSS_LOADER_EXPORT___;
